import { createI18n } from 'vue-i18n';
import es from '@/utils/language/translate/es.json';
import en from '@/utils/language/translate/en.json';

const i18n = createI18n(
  {
    locale: 'en',
    messages: {
      es,
      en,
    },
  },
);

export default i18n;
